"use client";

import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { fetcher } from "@/lib/http/fetcher";
import type { ProductForClient } from "@/lib/shared/types/interfaces";
import { searchKeys } from "../../shared/keys";

export function useSearchProducts(query: string) {
  const locale = useLocale();

  return useQuery<ProductForClient[]>({
    queryKey: searchKeys.products(query, locale),
    queryFn: () =>
      fetcher<ProductForClient[]>(
        `/${locale}/api/products/search?q=${encodeURIComponent(query)}&locale=${locale}`,
      ),
    enabled: !!query.trim(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
